import { NoDataException } from '../../../utils/exceptions/nodataexistsexception';
import { SalatiStatusDto, SalatiStatusDtoImpl } from './salatistatusdto';

export class SalatiStatusBuilder {
    constructor(private salatiStatusList: any) {
        if(salatiStatusList.responseDataList === undefined)
        {
            throw new NoDataException("Salati Status data doesnt exists");
        }
    }

    buildAll(): SalatiStatusDto[] {
        return this.parseSalatiStatusResponse();
    }
    
    private parseSalatiStatusResponse(): SalatiStatusDto[] {
        let listOfSalatiStatus: SalatiStatusDto[] = [];
        
        let salatiStatusDto = null;
        this.salatiStatusList.responseDataList.forEach((salatiStatusItem: any) =>
        {
            salatiStatusDto = new SalatiStatusDtoImpl();
            salatiStatusDto.setServiceName(salatiStatusItem.serviceName);
            salatiStatusDto.setSalatiStatus(salatiStatusItem.salatiStatus);
            
            listOfSalatiStatus.push(salatiStatusDto);
        });
        return listOfSalatiStatus;
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/salatistatus/salatistatusbuilder.ts